import { gql, useMutation } from '@apollo/client';
import { Switch } from '@headlessui/react';
import React, { useContext } from 'react';
import getModalContext from '../../../context/getModalContext';
import { ListingDetails_ListingData_listing } from '../../../types/graph/ListingDetails_ListingData';
import * as _ from 'lodash';

interface IProps {
  listing: ListingDetails_ListingData_listing;
}

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(' ');
}

const Advanced: React.FC<IProps> = ({ listing }) => {
  const modals = useContext(getModalContext());

  const [updateListing] = useMutation(UPDATE_LISTING);

  return (
    <div>
      {/* <div className="shadow rounded-lg bg-white">
        <div className="py-6 px-4 sm:p-6 lg:pb-8">Advanced</div>
      </div> */}
      <div className="bg-white shadow sm:rounded-lg">
        <div className="px-4 py-5 sm:p-6 flex justify-between">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              Status
            </h3>
            <div className="mt-2 max-w-xl text-sm text-gray-500">
              <p>Controls the state of your listing website online.</p>
            </div>
          </div>
          <div className="mt-5 mr-10">
            <Switch
              checked={_.get(listing, 'status', null) === 'active'}
              onChange={(checked) => {
                updateListing({
                  variables: {
                    listingId: listing.id,
                    listing: { status: checked ? 'active' : 'disabled' },
                  },
                });
              }}
              className={classNames(
                _.get(listing, 'status', null) === 'active'
                  ? 'bg-primary'
                  : 'bg-gray-200',
                'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light'
              )}
            >
              <span className="sr-only">Use setting</span>
              <span
                aria-hidden="true"
                className={classNames(
                  _.get(listing, 'status', null) === 'active'
                    ? 'translate-x-5'
                    : 'translate-x-0',
                  'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                )}
              />
            </Switch>
          </div>
        </div>
      </div>
      <div className="mt-4 bg-white shadow sm:rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Remove this listing
          </h3>
          <div className="mt-2 max-w-xl text-sm text-gray-500">
            <p>
              Once you delete your listing, you will lose all data associated
              with it.
            </p>
          </div>
          <div className="mt-5">
            <button
              type="button"
              className="inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
              onClick={() => {
                modals?.setModalState('listingDeleteModal', true, {
                  listingId: listing.id,
                });
              }}
            >
              Remove listing
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advanced;

const UPDATE_LISTING = gql`
  mutation ListingAdvanced_UpdateData(
    $listingId: String!
    $listing: ListingInput!
  ) {
    listingUpdate(listingId: $listingId, listing: $listing) {
      id
      property {
        address {
          street
          city
          region
          postal
          country
          lat
          lng
        }
        media {
          sid
          filePath
        }
      }
      website {
        styling {
          template
          colors {
            primary
            accent
          }
        }
      }
      contacts {
        id
        person {
          name {
            first
            last
            full
          }
          email
          phones {
            number
            type
          }
          socialLinks {
            url
            type
          }
          avatar {
            filePath
          }
        }
        company {
          name
          title
          socialLinks {
            url
            type
          }
          logo {
            filePath
          }
        }
      }
    }
  }
`;
